import { createFileRoute, useParams } from "@tanstack/react-router";

import { CustomerAlbumPage } from "@/features/album-share/CustomerAlbumPage";
import { PublicPageScroll } from "@/components/PublicPageScroll";

export const Route = createFileRoute("/booking/me_/orders/$orderId/album")({
  component: BookingCustomerOrderAlbumRoute,
});

function BookingCustomerOrderAlbumRoute() {
  const { orderId } = useParams({ from: "/booking/me_/orders/$orderId/album" });
  return (
    <PublicPageScroll>
      <CustomerAlbumPage orderId={orderId} />
    </PublicPageScroll>
  );
}
